export default __webpack_public_path__ + "static/media/sd.979c7eab.svg";